import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=22146c98&scoped=true"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=22146c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22146c98",
  null
  
)

export default component.exports